
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1974","fill":"#adadad"}},[_c('path',{attrs:{"data-name":"Path 1299","d":"M22 2v20H2V2h20m1-2H1a1 1 0 00-1 1v22a1 1 0 001 1h22a1 1 0 001-1V1a1 1 0 00-1-1z"}}),_c('path',{attrs:{"data-name":"Path 1300","d":"M13.512 20a1.9 1.9 0 01-1.663-1.18c-.248-.439-.307-.522-.687-.522A10.546 10.546 0 007.2 19.852a1 1 0 01-1.493-1.1l1.539-6.092-.981.395a1 1 0 11-.748-1.855l2.807-1.131a1 1 0 011.343 1.173l-1.475 5.843a8.044 8.044 0 012.97-.79 2.575 2.575 0 012.429 1.54l.087.151a32.925 32.925 0 003.925-.976 1 1 0 11.576 1.916A27.449 27.449 0 0113.512 20z"}}),_c('path',{attrs:{"data-name":"Path 1301","d":"M19 5.5H5a.5.5 0 010-1h14a.5.5 0 010 1z"}}),_c('path',{attrs:{"data-name":"Path 1302","d":"M19 8.5H5a.5.5 0 010-1h14a.5.5 0 010 1z"}})])])
          )
        }
      }
    